import "./BalanceIntentNames.mjs";
import { resolveCoinBalance } from "./CoinWithBalance.mjs";
import { resolveAllowanceBalance } from "./AllowanceBalance.mjs";
//#region src/transactions/intents/ResolveBalances.ts
async function resolveBalances(transactionData, options, next) {
	const intents = new Set(options.intentNames ?? ["AllowanceBalance", "CoinWithBalance"]);
	const shouldResolve = (name) => intents.has(name) && !options.supportedIntents?.includes(name) && transactionData.commands.some((command) => command.$Intent?.name === name);
	if (shouldResolve("AllowanceBalance")) await resolveAllowanceBalance(transactionData, options, async () => {});
	if (shouldResolve("CoinWithBalance")) await resolveCoinBalance(transactionData, options, async () => {});
	await next();
}
//#endregion
export { resolveBalances };

//# sourceMappingURL=ResolveBalances.mjs.map